<mat-card
    class="daxa-card recent-orders-card  border-radius bg-white border-none d-block p-3"
    [class.rtl-enabled]="themeService.isRTLEnabled()"
>
    <mat-card-header>
        <mat-card-title>
            <form class="search-box position-relative">
                <i class="material-symbols-outlined">
                    search
                </i>
                <input type="text" class="input-search d-block w-100 border-0 outline-0 rounded-pill "
                       placeholder="Chercher un Parameter..." (keyup)="applyFilter($event)" #input>
            </form>
        </mat-card-title>
        <mat-card-subtitle>
            <div class="btn-group">
                <button class="btn btn-outline-primary btn-sm rounded-start-pill" (click)="openModal(content)">
                    <i class="fa-solid fa-plus px-2"></i> Nouveau
                </button>
                <button class="btn btn-outline-primary btn-sm rounded-end-pill" [matMenuTriggerFor]="menu"
                    aria-haspopup="true" aria-expanded="false" id="dropdownMenuClickableInside">
                    <i class="fa-solid fa-sliders px-2"></i>
                </button>
            </div>
            
        </mat-card-subtitle>

    </mat-card-header>
    <mat-card-content>
        <div class="recent-orders-table">
            <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort>
    
                    <!-- select Column -->
                    <ng-container matColumnDef="select">
                        <th mat-header-cell *matHeaderCellDef>
                            <mat-checkbox (change)="handleSelectAll()" [checked]="isAllParameterSelected"/>
                        </th>
                        <td mat-cell *matCellDef="let element">
                            <mat-checkbox [checked]="isAllParameterSelected" (change)="handleSelection(element)"/>
                        </td>
                    </ng-container>
    
                    <!-- ID Column 
                    <ng-container matColumnDef="id">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                        <td mat-cell *matCellDef="let element"> {{ element.id }}</td>
                    </ng-container>
    -->
                    <!-- Code Parameter Column -->
                    <ng-container matColumnDef="codeParameter">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Code</th>
                        <td mat-cell *matCellDef="let element"> {{ element.codeParameter }}</td>
                    </ng-container>
                    <ng-container matColumnDef="sumVariants">
                        <th mat-header-cell *matHeaderCellDef mat-sort-header> Somme isomères </th>
                        <td mat-cell *matCellDef="let element"> {{ element.sumVariants ? 'Oui' : 'Non'}}</td>
                    </ng-container>
                    <!-- Nom Column -->
                    <ng-container matColumnDef="paramName">
                        <th mat-header-cell *matHeaderCellDef> Nom</th>
                        <td mat-cell *matCellDef="let element">
                            {{ element.pesticide?.pesticideResidueName || element.paramName }}
                        </td>

                    </ng-container>
    
                    <!-- Abréviation Column -->
                    <ng-container matColumnDef="abbreviation">
                        <th mat-header-cell *matHeaderCellDef> Abréviation</th>
                        <td mat-cell *matCellDef="let element"> {{ element.abbreviation }}</td>
                    </ng-container>
    
                    <!-- Norme Column -->
                    <ng-container matColumnDef="norme">
                        <th mat-header-cell *matHeaderCellDef> Norme</th>
                        <td mat-cell *matCellDef="let element"> {{ element.norme }}</td>
                    </ng-container>
    
                    <ng-container matColumnDef="formule">
                        <th mat-header-cell *matHeaderCellDef> Formule</th>
                        <td mat-cell *matCellDef="let element"> {{ element.formuleText }}</td>
                    </ng-container>
                    
                    
                    <!-- Description Column -->
                    <ng-container matColumnDef="description">
                        <th mat-header-cell *matHeaderCellDef> Description</th>
                        <td mat-cell *matCellDef="let element"> {{ element.description }}</td>
                    </ng-container>
    
                    <!-- Méthode Column -->
                    <ng-container matColumnDef="met">
                        <th mat-header-cell *matHeaderCellDef> Méthode</th>
                        <td mat-cell *matCellDef="let element"> {{ element.met }}</td>
                    </ng-container>
    
                    <!-- Durée Column -->
                    <ng-container matColumnDef="duree">
                        <th mat-header-cell *matHeaderCellDef> Durée</th>
                        <td mat-cell *matCellDef="let element"> {{ element.duree }}</td>
                    </ng-container>
    
                    <!-- Unité Column -->
                    <ng-container matColumnDef="unite">
                        <th mat-header-cell *matHeaderCellDef> Unité</th>
                        <td mat-cell *matCellDef="let element"> {{ element.unite }}</td>
                    </ng-container>
    
                    <!-- Unité Rapport Column -->
                    <ng-container matColumnDef="uniteRap">
                        <th mat-header-cell *matHeaderCellDef> Nom du rapport </th>
                        <td mat-cell *matCellDef="let element"> {{ element.uniteRap }}</td>
                    </ng-container>
    
                    <!-- Niveau Souhaitable Min Column -->
                    <ng-container matColumnDef="niveauSouhaitablemin">
                        <th mat-header-cell *matHeaderCellDef> Niveau Min</th>
                        <td mat-cell *matCellDef="let element"> {{ element.niveauSouhaitablemin }}</td>
                    </ng-container>
    
                    <!-- Niveau Souhaitable Max Column -->
                    <ng-container matColumnDef="niveauSouhaitablemax">
                        <th mat-header-cell *matHeaderCellDef> Niveau Max</th>
                        <td mat-cell *matCellDef="let element"> {{ element.niveauSouhaitablemax }}</td>
                    </ng-container>
    
                    <!-- MRI Column -->
                    <ng-container matColumnDef="mri">
                        <th mat-header-cell *matHeaderCellDef> MRI</th>
                        <td mat-cell *matCellDef="let element"> {{ element.mri }}</td>
                    </ng-container>
    
                    <!-- QC Column
                    <ng-container matColumnDef="qc">
                        <th mat-header-cell *matHeaderCellDef> QC</th>
                        <td mat-cell *matCellDef="let element"> {{ element.qc }}</td>
                    </ng-container>-->
    
                    <!-- Technique Column -->
                    <ng-container matColumnDef="technique">
                        <th mat-header-cell *matHeaderCellDef> Technique</th>
                        <td mat-cell *matCellDef="let element"> {{ element.technique }}</td>
                    </ng-container>
    
                    <!-- Nom Famille Column -->
                    <ng-container matColumnDef="nomFamille">
                        <th mat-header-cell *matHeaderCellDef> Nom Famille</th>
                        <td mat-cell *matCellDef="let element"> {{ element.nomFamille }}</td>
                    </ng-container>
    
                    <!-- Arabic Name Column
                    <ng-container matColumnDef="arabicName">
                        <th mat-header-cell *matHeaderCellDef> Nom Arabe</th>
                        <td mat-cell *matCellDef="let element"> {{ element.arabicName }}</td>
                    </ng-container> -->
    
    
                    <!-- Souche Controle Column
                    <ng-container matColumnDef="soucheControle">
                        <th mat-header-cell *matHeaderCellDef> Souche Contrôle</th>
                        <td mat-cell *matCellDef="let element"> {{ element.soucheControle }}</td>
                    </ng-container> -->
    
                    <!-- Sous Traite Column -->
                    <ng-container matColumnDef="sousTraite">
                <th mat-header-cell *matHeaderCellDef> Sous-traité </th>
                <td mat-cell *matCellDef="let element">
                    {{ element.sousTraite ? 'Oui' : 'Non' }}
                </td>
                </ng-container>

                    
    
                    <!-- Date de création Column -->
                    <ng-container matColumnDef="creationDate">
                        <th mat-header-cell *matHeaderCellDef> Date de création</th>
                        <td mat-cell *matCellDef="let element"> {{ element.creationDate | date: 'shortDate' }}</td>
                    </ng-container>
    
                    <!-- Date de mise à jour Column -->
                    <ng-container matColumnDef="updateDate">
                        <th mat-header-cell *matHeaderCellDef> Date de mise à jour</th>
                        <td mat-cell *matCellDef="let element"> {{ element.updateDate | date: 'shortDate' }}</td>
                    </ng-container>
    
                    <!-- Créé par Column -->
                    <ng-container matColumnDef="createdBy">
                        <th mat-header-cell *matHeaderCellDef> Créé par</th>
                        <td mat-cell *matCellDef="let element"> {{ element.createdByName || 'N/A' }}</td>
                    </ng-container>
    
                    <!-- Action Column -->
                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="text-center"> Action</th>
                        <td mat-cell *matCellDef="let element">
                            <div class="action-info text-center">
                                <button mat-button (click)="openViewModel(element)">
                                    <i class="material-symbols-outlined">visibility</i>
                                </button>
                                <button mat-button (click)="editParameter(element)">
                                    <i class="material-symbols-outlined text-primary">brush</i>
                                </button>
                                <button mat-button (click)="confirmDelete(element)">
                                    <i class="material-symbols-outlined text-danger">delete</i>
                                </button>
                            </div>
                        </td>
                    </ng-container>
    
                    <tr mat-header-row *matHeaderRowDef="getdisplayedCol()"></tr>
                    <tr mat-row *matRowDef="let row; columns: getdisplayedCol();"></tr>
    
                </table>
                <div *ngIf="loadingTable">
                    <div *ngFor="let i of [].constructor(6)" class="skeleton-row">
                        <span class="skeleton-cell"></span>
                    </div>
                </div>
            </div>
            <mat-paginator [pageSizeOptions]="[5, 10, 20]" showFirstLastButtons></mat-paginator>

            </div>
    </mat-card-content>
    
    
    
</mat-card>


<ng-template #content let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Créer un Parameter</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveParameter()">
                <div class="row">
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Code</mat-label>
                            <input matInput formControlName="codeParameter" required>
                            <mat-error *ngIf="form.get('codeParameter')?.hasError('required')">Code requis</mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Nom de Famille -->
                    <div class="col-sm-12 col-md-6">
                     <mat-form-field class="mb-3">
                        <mat-label>Nom de Famille</mat-label>
                        <mat-select formControlName="nomFamille">
                        <mat-option value="PESTICIDE">Pesticide</mat-option>
                        <mat-option value="AUTRE">Autre</mat-option>
                        </mat-select>
                     </mat-form-field>
                    </div>
                    <!-- Nom -->
                    <div class="col-sm-12 col-md-6">
                    <ng-container *ngIf="selectedNomFamille === 'PESTICIDE'; else simpleInput">
                        <mat-form-field appearance="fill" class="w-100" style="margin-bottom: 10px;">
                        <mat-label>Pesticide Nom</mat-label>
                        <input
                            type="text"
                            matInput
                            [formControl]="pesticideControl"
                            [matAutocomplete]="auto"
                            placeholder="Rechercher un pesticide"
                            (focus)="onInputFocus()"
                        />
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPesticideName.bind(this)">
                            <mat-option *ngFor="let pesticide of filteredPesticides" [value]="pesticide.id">
                            {{ pesticide.pesticideResidueName }}
                            </mat-option>
                        </mat-autocomplete>
                        <mat-error *ngIf="pesticideControl.hasError('required')">Champ requis</mat-error>
                        </mat-form-field>
                    </ng-container>

                    <ng-template #simpleInput>
                        <mat-form-field class="mb-3">
                        <mat-label>Nom Molécule</mat-label>
                        <input matInput formControlName="paramName">
                        <mat-error *ngIf="form.get('paramName')?.hasError('required')">Nom requis</mat-error>
                        </mat-form-field>
                    </ng-template>
                    </div>

                    <!-- Code Parameter
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Cas Number</mat-label>
                            <input matInput formControlName="casNumber">
                        </mat-form-field>
                    </div>  -->
                  <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Nom du rapport</mat-label>
                            <input matInput formControlName="uniteRap">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-6">
                    <label class="fw-bold d-block mb-2">Sommer les variants</label>
                    <mat-radio-group formControlName="sumVariants" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Oui</mat-radio-button>
                        <mat-radio-button [value]="false">Non</mat-radio-button>
                    </mat-radio-group>
                </div>
                    <!-- Abréviation -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Abréviation</mat-label>
                            <input matInput formControlName="abbreviation">
                        </mat-form-field>
                    </div>

                    <!-- Norme -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Norme</mat-label>
                            <input matInput formControlName="norme">
                        </mat-form-field>
                    </div>
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Formule</mat-label>
                            <mat-select formControlName="formule" placeholder="Sélectionner la formule">
                                <mat-option *ngFor="let terrain of formuleList" [value]="terrain.id">
                                    {{ terrain.formule }}
                                </mat-option>                                
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <!-- Description -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description" ></textarea>
                        </mat-form-field>
                    </div>

            
                    

                    <!-- Méthode -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Méthode</mat-label>
                            <input matInput formControlName="met">
                        </mat-form-field>
                    </div>

                    <!-- Durée -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Durée</mat-label>
                            <input matInput formControlName="duree">
                        </mat-form-field>
                    </div>

                    <!-- Unité -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Unité</mat-label>
                            <input matInput formControlName="unite">
                        </mat-form-field>
                    </div>

                    <!-- Unité de Rapport -->


                    <!-- Niveau Souhaitable Min/Max -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Niveau souhaitable Min</mat-label>
                            <input matInput type="number" formControlName="niveauSouhaitablemin">
                        </mat-form-field>
                    </div>

                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Niveau souhaitable Max</mat-label>
                            <input matInput type="number" formControlName="niveauSouhaitablemax">
                        </mat-form-field>
                    </div>

                    <!-- MRI & QC -->
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>MRI</mat-label>
                            <input matInput type="number" formControlName="mri">
                        </mat-form-field>
                    </div>
 <!-- 
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>QC</mat-label>
                            <input matInput type="number" formControlName="qc">
                        </mat-form-field>
                    </div>
-->
                    <!-- Méthode
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Méthode</mat-label>
                            <input matInput formControlName="method">
                        </mat-form-field>
                    </div>
 -->
                    <!-- Technique -->
                    <div class="col-sm-12 col-md-6">
  <mat-form-field class="mb-3" appearance="fill">
    <mat-label>Technique</mat-label>
    <mat-select formControlName="technique" required>
      <mat-option [value]="'GCMSMS'">GCMSMS</mat-option>
      <mat-option [value]="'LCMSMS'">LCMSMS</mat-option>
    </mat-select>
    <mat-error *ngIf="form.get('technique')?.hasError('required')">
      La technique est obligatoire
    </mat-error>
  </mat-form-field>
</div>


                                    <!-- Sous Traite -->
                <div class="col-sm-6 col-lg-4">
                    <label class="fw-bold d-block mb-2">Sous-traité</label>
                    <mat-radio-group formControlName="sousTraite" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Oui</mat-radio-button>
                        <mat-radio-button [value]="false">Non</mat-radio-button>
                    </mat-radio-group>
                </div>
                

                    <!-- Date de création 
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Date de création</mat-label>
                            <input matInput readonly [matDatepicker]="creationPicker" formControlName="creationDate" required>
                            <mat-datepicker-toggle matIconSuffix [for]="creationPicker"></mat-datepicker-toggle>
                            <mat-datepicker #creationPicker></mat-datepicker>
                        </mat-form-field>
                    </div>-->

                    <!-- Date de mise à jour
                    <div class="col-sm-12 col-md-6">
                        <mat-form-field class="mb-3">
                            <mat-label>Date de mise à jour</mat-label>
                            <input matInput readonly [matDatepicker]="updatePicker" formControlName="updateDate">
                            <mat-datepicker-toggle matIconSuffix [for]="updatePicker"></mat-datepicker-toggle>
                            <mat-datepicker #updatePicker></mat-datepicker>
                        </mat-form-field>
                    </div>
 -->
                    <!-- Bouton d'enregistrement -->
                    <div class="col-sm-12 text-right mt-3">
                        <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                    </div>
                    
                </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>


<!--modal template for infos -->
<ng-template #viewModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <h5 class="fw-bold mx-3">
            Détails du Parameter
        </h5>
        <div class="row m-3">
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Code Parameter :</div>
                <p>{{ form.get('codeParameter')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top border-0 p-3">
                <div class="fw-bold">Code Parameter :</div>
                <p>{{ form.get('sumVariants')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Nom :</div>
                <p>{{ form.get('paramName')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Abréviation :</div>
                <p>{{ form.get('abbreviation')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Norme :</div>
                <p>{{ form.get('norme')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Description :</div>
                <p>{{ form.get('description')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Unité :</div>
                <p>{{ form.get('unite')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Nom du rapport:</div>
                <p>{{ form.get('uniteRap')?.value }}</p>
            </div>

            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Méthode :</div>
                <p>{{ form.get('met')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Technique :</div>
                <p>{{ form.get('technique')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Niveau souhaitable (Min - Max) :</div>
                <p>{{ form.get('niveauSouhaitablemin')?.value }} - {{ form.get('niveauSouhaitablemax')?.value }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Date de création :</div>
                <p>{{ form.get('creationDate')?.value | date: 'shortDate' }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Date de mise à jour :</div>
                <p>{{ form.get('updateDate')?.value | date: 'shortDate' }}</p>
            </div>
            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Formule :</div>
                <p>{{ form.get('formuleText')?.value || 'Non renseigné' }}</p>
            </div>

            <div class="col-sm-6 col-lg-4 border-top p-3">
                <div class="fw-bold">Créé par :</div>
                <p>{{ form.get('createdByName')?.value || 'Non renseigné' }}</p>
            </div>

        </div>
    </mat-card>
</ng-template>


<ng-template #editModal let-modal>
    <mat-card class="daxa-card border-radius bg-white border-none d-block">
        <mat-card-header>
            <mat-card-title>
                <h5 class="mt-0 mb-0">Modifier Parameter</h5>
            </mat-card-title>
        </mat-card-header>
        <mat-card-content>
            <form [formGroup]="form" (ngSubmit)="saveUpdatedParameter()">
                <div class="row">
                    
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Code Parameter</mat-label>
                            <input matInput formControlName="codeParameter" required>
                            <mat-error *ngIf="form.get('codeParameter')?.hasError('required')">Code requis</mat-error>
                        </mat-form-field>
                    </div>
                    <!-- Nom Famille -->
                    <div class="col-sm-6 col-lg-4">
                    <mat-form-field appearance="fill" class="w-100 mb-3">
                        <mat-label>Nom Famille</mat-label>
                        <mat-select formControlName="nomFamille">
                        <mat-option [value]="'PESTICIDE'">Pesticide</mat-option>
                        <mat-option [value]="'MOLECULE'">Molécule</mat-option>
                        <mat-option [value]="'AUTRE'">Autre</mat-option>
                        </mat-select>
                    
                    </mat-form-field>  
                    </div>

                    <div class="col-sm-6 col-lg-4">
                    <div *ngIf="selectedNomFamille === 'PESTICIDE'; else autreMolecule">
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Pesticide Nom</mat-label>
                        <input
                        type="text"
                        matInput
                        [formControl]="pesticideControl"
                        [matAutocomplete]="auto"
                        placeholder="Rechercher un pesticide"
                        (focus)="onInputFocus()"
                        />
                        <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayPesticideName.bind(this)">
                    <mat-option *ngFor="let pesticide of filteredPesticides" [value]="pesticide.id">
                    {{ pesticide.pesticideResidueName }}
                    </mat-option>


                        </mat-autocomplete>
                    </mat-form-field>
                    </div>

                    <!-- AUTRES MOLECULES => Champ texte -->
                    <ng-template #autreMolecule>
                    <mat-form-field appearance="fill" class="w-100">
                        <mat-label>Nom de Molécule</mat-label>
                        <input matInput formControlName="name" placeholder="Nom de molécule">
                    </mat-form-field>
                    </ng-template>
                    </div>
                   <div class="col-sm-6 col-lg-4">
                    <label class="fw-bold d-block mb-2">Sommer les variants</label>
                    <mat-radio-group formControlName="sumVariants" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Oui</mat-radio-button>
                        <mat-radio-button [value]="false">Non</mat-radio-button>
                    </mat-radio-group>
                    </div>

                    <!-- Abbreviation -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Abréviation</mat-label>
                            <input matInput formControlName="abbreviation">
                        </mat-form-field>
                    </div>

                    <!-- Norme -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Norme</mat-label>
                            <input matInput formControlName="norme">
                        </mat-form-field>
                    </div>

                    <!-- Description -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Description</mat-label>
                            <textarea matInput formControlName="description"></textarea>
                        </mat-form-field>
                    </div>

                    <!-- Duree -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Durée</mat-label>
                            <input matInput formControlName="duree">
                        </mat-form-field>
                    </div>

                    <!-- Method -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Méthode</mat-label>
                            <input matInput formControlName="met">
                        </mat-form-field>
                    </div>
                    <!-- Unite -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Unité</mat-label>
                            <input matInput formControlName="unite">
                        </mat-form-field>
                    </div>

                    <!-- UniteRap -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Nom du rapport</mat-label>
                            <input matInput formControlName="uniteRap">
                        </mat-form-field>
                    </div>

                    <!-- Niveau Souhaitable Min -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Niveau souhaitable Min</mat-label>
                            <input matInput type="number" formControlName="niveauSouhaitablemin">
                        </mat-form-field>
                    </div>

                    <!-- Niveau Souhaitable Max -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Niveau souhaitable Max</mat-label>
                            <input matInput type="number" formControlName="niveauSouhaitablemax">
                        </mat-form-field>
                    </div>

                    <!-- Mri -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>MRI</mat-label>
                            <input matInput formControlName="mri">
                        </mat-form-field>
                    </div>

                    <!-- Qc
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>QC</mat-label>
                            <input matInput formControlName="qc">
                        </mat-form-field>
                    </div> -->

                    <!-- Technique -->
                    <!-- Technique (Update) -->
                    <div class="col-sm-6 col-lg-4">
                    <mat-form-field class="mb-25" appearance="fill">
                        <mat-label>Technique</mat-label>
                        <mat-select formControlName="technique" required>
                        <mat-option [value]="'GCMSMS'">GCMSMS</mat-option>
                        <mat-option [value]="'LCMSMS'">LCMSMS</mat-option>
                        </mat-select>
                    
                    </mat-form-field>
                    </div>

                    <!-- Création Date -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                            <mat-label>Date de création</mat-label>
                            <input matInput readonly [matDatepicker]="picker" formControlName="creationDate">
                            <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
                            <mat-datepicker #picker></mat-datepicker>
                        </mat-form-field>
                    </div>

                    <!-- Created By -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Créé par</mat-label>
                        <input matInput formControlName="createdBy" readonly>
                        </mat-form-field>
                    </div>
                    <!-- Formule -->
                    <div class="col-sm-6 col-lg-4">
                        <mat-form-field class="mb-25">
                        <mat-label>Formule</mat-label>
                        <mat-select formControlName="formule">
                            <mat-option *ngFor="let formule of formuleList" [value]="formule.formule">
                            {{ formule.formule }}
                            </mat-option>
                        </mat-select>
                        </mat-form-field>
                    </div>
                <!-- Sous Traite -->
                <div class="col-sm-6 col-lg-4">
                    <label class="fw-bold d-block mb-2">Sous-traité</label>
                    <mat-radio-group formControlName="sousTraite" class="d-flex gap-4">
                        <mat-radio-button [value]="true">Oui</mat-radio-button>
                        <mat-radio-button [value]="false">Non</mat-radio-button>
                    </mat-radio-group>
                </div>


                <!-- Submit Button -->
                <div class="col-sm-12 text-right mt-3">
                    <button type="submit" class="btn btn-outline-success">Enregistrer</button>
                </div>
            </div>
            </form>
        </mat-card-content>
    </mat-card>
</ng-template>



<!-- Menu with Checkboxes -->
<mat-menu #menu="matMenu">
    <div class="scrollable-menu shadow-lg bg-body">
        <mat-checkbox [checked]="displayedColumns.length == columns.length" (change)=" handleIsAllColsSelected($event)"
                      (click)="$event.stopPropagation()">Tous
        </mat-checkbox>
        @for (col of columns; track $index) {
            <div>
                <mat-checkbox [value]="col"
                              [checked]="displayedColumns.includes(col) || displayedColumns.length == columns.length"
                              (click)="$event.stopPropagation(); onSelectionChange(col)">
                    {{ columnLabels[col] || col }}
                </mat-checkbox>
            </div>
        }
    </div>

</mat-menu>
